export const getMemesRequest = (page = 1, per = 5) => {
  return fetch(`${process.env.REACT_APP_PURRS_API_HOST}/api/v1/memes?page=${page}&per=${per}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json;",
    },
  })
  .then((response) => response.json())
  .then((data) => {
    return data;
  })
  .catch((error) => {
    console.log("Memes error", error);
  });
}

export const getMemeRequest = (meme_identifier: string) => {
  return fetch(`${process.env.REACT_APP_PURRS_API_HOST}/api/v1/memes/${meme_identifier}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json;",
    },
  })
  .then((response) => response.json())
  .then((data) => {
    return data;
  })
  .catch((error) => {
    console.log("Memes error", error);
  });
}

export const postMemeRequest = (body: any) => {
  return fetch(`${process.env.REACT_APP_PURRS_API_HOST}/api/v1/memes`, {
    method: "POST",
    headers: {
      
    },
    body: body
  })
  .then((response) => response.json())
  .then((data) => {
    return data;
  })
  .catch((error) => {
    console.log("Memes error", error);
  });
}

export const getPhotosRequest = (page = 1, per = 1) => {
  return fetch(`${process.env.REACT_APP_PURRS_API_HOST}/api/v1/memes/photos?page=${page}&per=${per}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json;",
    },
  })
  .then((response) => response.json())
  .then((data) => {
    return data;
  })
  .catch((error) => {
    console.log("Img error", error);
  });
}

export const getPhotoRequest = (kitten_identifier: string, photo_id: string) => {
  return fetch(`${process.env.REACT_APP_PURRS_API_HOST}/api/v1/memes/photo/${kitten_identifier}/${photo_id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json;",
    },
  })
  .then((response) => response.json())
  .then((data) => {
    return data;
  })
  .catch((error) => {
    console.log("Img error", error);
  });
}